// extracted by css-extract-rspack-plugin
export default {"stockIcon":"stockIcon-xQIIRo"};